import { connect } from 'react-redux'
import { lifecycle, compose } from 'recompose'
import { withTireSize } from 'components/VehicleConfigurator'
import { initialize } from './actions'
import CustomTireSize from './CustomTireSize'

export default compose(
  withTireSize,
  connect(null, { initialize }),
  lifecycle({
    componentDidMount() {
      const { tireSizeFrontWidthValues, isModal, setDefaultState } = this.props
      if (!tireSizeFrontWidthValues || !tireSizeFrontWidthValues.length) {
        this.props.initialize({ isModal })
      }
      setDefaultState({ isModal })
    }
  })
)(CustomTireSize)
